import type {
  CrudFormItem,
  CrudSearchItem,
  CrudTableColumn
} from '@/types/crud-config'
import type { DeductItemFlow, DeductItemRecord } from './deduct-item.service'

export interface DeductItemForm {
  reason: string
  flow: DeductItemFlow | ''
  point: number | string
}

const flowOptions = [
  { label: '减积分', value: '0' },
  { label: '加积分', value: '1' }
]

export const deductItemSearchItems: CrudSearchItem[] = [
  {
    label: '流向',
    prop: 'flow',
    type: 'select',
    controlClass: 'deduct-item-page__search-control',
    clearable: true,
    placeholder: '请选择流向',
    options: flowOptions
  },
  {
    label: '原因',
    prop: 'reason',
    type: 'input',
    controlClass: 'deduct-item-page__search-control',
    clearable: true,
    placeholder: '请输入原因'
  }
]

export const deductItemFormItems: CrudFormItem<DeductItemForm>[] = [
  {
    label: '原因',
    prop: 'reason',
    type: 'input',
    clearable: true,
    placeholder: '请输入原因'
  },
  {
    label: '流向',
    prop: 'flow',
    type: 'select',
    placeholder: '请选择流向',
    options: flowOptions
  },
  {
    label: '积分数量',
    prop: 'point',
    type: 'input',
    placeholder: '请输入积分数量'
  }
]

export function createDeductItemTableColumns(
  showActions: boolean
): CrudTableColumn<DeductItemRecord>[] {
  const columns: CrudTableColumn<DeductItemRecord>[] = [
    {
      prop: 'reason',
      label: '原因',
      minWidth: 160,
      showOverflowTooltip: true
    },
    {
      prop: 'flow',
      label: '流向',
      minWidth: 100,
      showOverflowTooltip: true,
      formatter: (row) => (row.flow === '0' ? '减积分' : '加积分')
    },
    {
      prop: 'point',
      label: '积分数量',
      minWidth: 110,
      showOverflowTooltip: true
    }
  ]

  if (showActions) {
    columns.push({
      label: '操作',
      slot: 'rowActions',
      width: 180,
      fixed: 'right'
    })
  }

  return columns
}
